import Logo from '../../misc/Logo'
import ToolDrawer from './ToolDrawer'
import { Link } from 'react-router-dom'
import { Icons } from '../../misc/Icons'
import { observer } from 'mobx-react-lite'
import { store } from '../../stores/Store'
import { Button, Toolbar } from '@mui/material'

export default observer(function PrimarySearchAppBar() {

    const logoPath = store.AppStore.sessionInfo?.customLogoUrl
    const supportUrl = store.AppStore.sessionInfo?.accountPreferences?.support_url

    return (
        <div className="nav-header">
            {store.AppStore.isLoggedIn && <ToolDrawer />}

            <Button 
                component={Link} 
                aria-label='Home' 
                color="info" 
                style={{margin: 0}}
                className="logo-button" 
                to="/app/main">
                {logoPath ? (
                    <img src={logoPath} style={{height: "35px"}} alt="Logo" />
                ) : (
                    <Logo height="20px" color="white" type="block" />
                )}
            </Button>

            {supportUrl ? (
                <a target="_blank" rel="noreferrer" href={supportUrl} style={{marginLeft: "auto"}}>
                    <Button className="btn btn-sm" variant="contained" color="info">
                        <Icons.Support />
                        <h4 style={{color: "#444444"}}>Support</h4>
                    </Button>
                </a>
            ) : null}
        </div>
    )
})